import { StatusLaporan, TingkatRisiko } from '../../types';

// Helper sederhana untuk mengganti 'cn' agar tidak ada error import
const cn = (...classes: any[]) => classes.filter(Boolean).join(' ');

// ✅ STATUS LABELS YANG USER-FRIENDLY
const STATUS_CONFIG: Record<string, {
  label: string;
  shortLabel?: string;
  description?: string;
  bgColor: string;
  textColor: string;
  dotColor?: string;
}> = {
  // === FASE DRAFT ===
  draf: {
    label: 'Draf',
    shortLabel: 'Draf',
    description: 'Laporan masih dalam penyusunan',
    bgColor: 'bg-gray-100', textColor: 'text-gray-700', dotColor: 'bg-gray-400',
  },
  draft: {
    label: 'Draf',
    shortLabel: 'Draf',
    description: 'Laporan masih dalam penyusunan',
    bgColor: 'bg-gray-100', textColor: 'text-gray-700', dotColor: 'bg-gray-400',
  },
  diajukan: {
    label: 'Menunggu Persetujuan Dekan / Ketua Lembaga',
    shortLabel: 'Menunggu Persetujuan',
    description: 'Laporan sedang ditinjau oleh Dekan / Ketua Lembaga',
    bgColor: 'bg-blue-100', textColor: 'text-blue-700', dotColor: 'bg-blue-500',
  },
  validasi_l1: {
    label: 'Disetujui Dekan/K.Lembaga • Menunggu Warek',
    shortLabel: 'Menunggu Wakil Rektor',
    description: 'Dekan / Ketua Lembaga telah menyetujui, menunggu persetujuan Wakil Rektor bidang terkait',
    bgColor: 'bg-indigo-100', textColor: 'text-indigo-700', dotColor: 'bg-indigo-500',
  },
  validasi_l2: {
    label: 'Disetujui Wakil Rektor • Siap Diagendakan',
    shortLabel: 'Siap Rapat Pimpinan',
    description: 'Semua persetujuan selesai, siap diagendakan dalam Rapat Pimpinan',
    bgColor: 'bg-purple-100', textColor: 'text-purple-700', dotColor: 'bg-purple-500',
  },
  ditolak_l1: {
    label: 'Dikembalikan oleh Dekan / Ketua Lembaga',
    shortLabel: 'Perlu Diperbaiki',
    description: 'Dekan / Ketua Lembaga meminta perbaikan sebelum dapat disetujui',
    bgColor: 'bg-amber-100', textColor: 'text-amber-700', dotColor: 'bg-amber-500',
  },
  ditolak_l2: {
    label: 'Dikembalikan oleh Wakil Rektor',
    shortLabel: 'Perlu Diperbaiki',
    description: 'Wakil Rektor meminta perbaikan pada laporan',
    bgColor: 'bg-amber-100', textColor: 'text-amber-700', dotColor: 'bg-amber-500',
  },
  antrean_rapim: {
    label: 'Dalam Antrean Rapat Pimpinan',
    shortLabel: 'Antrean Rapat',
    description: 'Menunggu jadwal pembahasan di Rapat Pimpinan',
    bgColor: 'bg-cyan-100', textColor: 'text-cyan-700', dotColor: 'bg-cyan-500',
  },
  diputuskan: {
    label: 'Keputusan Rapat Pimpinan Ditetapkan',
    shortLabel: 'Sudah Diputuskan',
    description: 'Keputusan tindak lanjut telah ditetapkan dalam Rapat Pimpinan',
    bgColor: 'bg-teal-100', textColor: 'text-teal-700', dotColor: 'bg-teal-500',
  },
  berlangsung: {
    label: 'Sedang Dikerjakan',
    shortLabel: 'Dikerjakan',
    description: 'Tindak lanjut sedang dalam proses pengerjaan oleh PIC',
    bgColor: 'bg-sky-100', textColor: 'text-sky-700', dotColor: 'bg-sky-500',
  },
  menunggu_konfirmasi: {
    label: 'Menunggu Konfirmasi Selesai',
    shortLabel: 'Konfirmasi',
    description: 'Menunggu konfirmasi penyelesaian dari pimpinan',
    bgColor: 'bg-amber-100', textColor: 'text-amber-700', dotColor: 'bg-amber-500',
  },
  selesai: {
    label: 'Selesai',
    shortLabel: 'Selesai',
    description: 'Semua tindak lanjut telah diselesaikan dan dikonfirmasi',
    bgColor: 'bg-emerald-100', textColor: 'text-emerald-700', dotColor: 'bg-emerald-500',
  },
  diarsipkan: {
    label: 'Diarsipkan',
    shortLabel: 'Arsip',
    description: 'Laporan telah dipindahkan ke arsip',
    bgColor: 'bg-slate-100', textColor: 'text-slate-600', dotColor: 'bg-slate-400',
  },
  diselesaikan_lokal: {
    label: 'Ditangani Langsung oleh Pimpinan',
    shortLabel: 'Selesai Lokal',
    description: 'Masalah diselesaikan oleh pimpinan tanpa perlu Rapat Pimpinan',
    bgColor: 'bg-green-100', textColor: 'text-green-700', dotColor: 'bg-green-500',
  },
};

const RISK_CONFIG: Record<string, { label: string; bgColor: string; textColor: string; dotColor: string }> = {
  rendah: { label: 'Rendah', bgColor: 'bg-green-100', textColor: 'text-green-700', dotColor: 'bg-green-500' },
  low: { label: 'Rendah', bgColor: 'bg-green-100', textColor: 'text-green-700', dotColor: 'bg-green-500' },
  sedang: { label: 'Sedang', bgColor: 'bg-yellow-100', textColor: 'text-yellow-700', dotColor: 'bg-yellow-500' },
  medium: { label: 'Sedang', bgColor: 'bg-yellow-100', textColor: 'text-yellow-700', dotColor: 'bg-yellow-500' },
  tinggi: { label: 'Tinggi', bgColor: 'bg-orange-100', textColor: 'text-orange-700', dotColor: 'bg-orange-500' },
  high: { label: 'Tinggi', bgColor: 'bg-orange-100', textColor: 'text-orange-700', dotColor: 'bg-orange-500' },
  kritis: { label: 'Kritis', bgColor: 'bg-red-100', textColor: 'text-red-700', dotColor: 'bg-red-500' },
  critical: { label: 'Kritis', bgColor: 'bg-red-100', textColor: 'text-red-700', dotColor: 'bg-red-500' },
};

export function getStatusConfig(status: string) {
  return STATUS_CONFIG[status?.toLowerCase()] || {
    label: status,
    bgColor: 'bg-gray-100',
    textColor: 'text-gray-700',
  };
}

interface BadgeProps {
  variant?: 'status' | 'risk' | 'custom' | 'default' | 'priority';
  status?: string;
  risk?: string;
  priority?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  children?: React.ReactNode;
  className?: string;
  showDot?: boolean;
  useShortLabel?: boolean;
  showTooltip?: boolean;
}

const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  status,
  risk,
  size = 'sm',
  children,
  className,
  showDot = false,
  useShortLabel = false,
  showTooltip = false,
}) => {
  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-[10px]',
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  if (variant === 'status' && status) {
    const config = getStatusConfig(status);
    const label = useShortLabel ? (config.shortLabel || config.label) : config.label;

    const badge = (
      <span
        className={cn(
          'inline-flex items-center gap-1.5 font-semibold rounded-full whitespace-nowrap',
          config.bgColor,
          config.textColor,
          sizeClasses[size as keyof typeof sizeClasses] || sizeClasses.sm,
          className
        )}
      >
        {showDot && config.dotColor && (
          <span className={cn('w-1.5 h-1.5 rounded-full', config.dotColor)} />
        )}
        {label}
      </span>
    );

    if (showTooltip && config.description) {
      return (
        <div className="group relative inline-flex">
          {badge}
          <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all whitespace-nowrap z-50">
            {config.description}
            <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900" />
          </div>
        </div>
      );
    }

    return badge;
  }

  if (variant === 'risk' && risk) {
    const config = RISK_CONFIG[risk?.toLowerCase()] || RISK_CONFIG.sedang;
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1.5 font-semibold rounded-full',
          config.bgColor,
          config.textColor,
          sizeClasses[size as keyof typeof sizeClasses] || sizeClasses.sm,
          className
        )}
      >
        {showDot && (
          <span className={cn('w-1.5 h-1.5 rounded-full', config.dotColor)} />
        )}
        {config.label}
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-full bg-gray-100 text-gray-700',
        sizeClasses[size as keyof typeof sizeClasses] || sizeClasses.sm,
        className
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
